'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.kubernetes.securityGroup.reader', [
])
  .factory('kubernetesSecurityGroupReader', function () {

    function resolveIndexedSecurityGroup(indexedSecurityGroups, container, securityGroupId) {
      return indexedSecurityGroups[container.account][container.region][securityGroupId];
    }

    return {
      resolveIndexedSecurityGroup: resolveIndexedSecurityGroup,
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/kubernetes/src/securityGroup/reader.js